// extracted by mini-css-extract-plugin
export default {"swapWatchwordsList":"ScoringSwapWatchwordsListModal_swapWatchwordsList__gE08h"};